import { configuratorStep, actions as mainActions } from '../main';

function setGtmPageView(name) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'pageview', pageName: name });
}

function createGtmMiddleware(extraArgument) {
  return ({ dispatch, getState }) =>
    (next) =>
    (action) => {
      if (typeof action === 'function') {
        return action(dispatch, getState, extraArgument);
      } else {
        if (action.type === mainActions.SET_CURRENTSTEP) {
          //TODO Expected a default case  default-case
          switch (action.payload) {
            case configuratorStep.bom:
              setGtmPageView('Studio v3: Step 1');
              break;
            case configuratorStep.imprintarea:
              setGtmPageView('Studio v3: Step 1a - Imprint Location');
              break;
            case configuratorStep.canvas:
              setGtmPageView('Studio v3: Step 2');
              break;
            case configuratorStep.template:
              setGtmPageView('Studio v3: Step 1b - Imprint Options – Background');
              break;
          }
        }
      }

      return next(action);
    };
}

const gtmMiddleware = createGtmMiddleware();
gtmMiddleware.withExtraArgument = createGtmMiddleware;

export default gtmMiddleware;
